import { gql } from '@apollo/client';
import { INBOX_ITEM_FIELDS } from '../queries/inbox';

export const ATTEND_INBOX_ITEM = gql`
  mutation AttendInboxItem($id: ID!) {
    attendInboxItem(id: $id) {
      ...InboxItemFields
    }
  }
  ${INBOX_ITEM_FIELDS}
`;
